import { CUSTOMER_API_ENDPOINT } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientCustomer = httpClientFactory({
  baseURL: CUSTOMER_API_ENDPOINT(),
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
